import moment from 'moment';
import {
  FAILURE_WEATHER,
  FAILURE_PAST_WEATHER,
  REQUEST_PAST_WEATHER,
  RECEIVE_PAST_WEATHER,
  UPDATE_PAST_WEATHER_VALUE,
  RECEIVE_HISTORICAL_WEATHER,
  CLEAR_HISTORICAL_DATA,
  TOGGLE_PRECIPITATION_HELP,
  TOGGLE_TEMPERATURE_HELP,
  REQUEST_HISTORICAL_WEATHER,
  CLEAR_PAST_WEATHER_FAILURE,
} from '../constants/actionTypes';
import { accumulateData } from '../utils/chartUtils';
import { pastWeatherErrorHandler } from '../utils/pastWeatherErrorHanlder';

export const initialState = {
  error: undefined,
  pastWeatherError: '',
  isFetching: false,
  startDate: moment().subtract(365, 'd').toISOString(),
  endDate: moment().toISOString(),
  harvestYear: '',
  formattedDates: [],
  yearAverage: 'None', // TODO: Either needs to be set via i18n or empty string
  accumulatedPrecipitation: {
    past: {
      q: [],
      u: 'millimeter',
    },
    historical: {
      q: [],
      u: 'millimeter',
    },
  },
  precipitation: {
    past: {
      q: [],
      u: 'millimeter',
    },
    historical: {
      q: [],
      u: 'millimeter',
    },
    help: false,
  },
  temperature: {
    past: {
      max: {
        q: [],
        u: 'celsius',
      },
      min: {
        q: [],
        u: 'celsius',
      },
    },
    historical: {
      max: {
        q: [],
        u: 'celsius',
      },
      min: {
        q: [],
        u: 'celsius',
      },
    },
    help: false,
  },
};

function pastWeatherReducer(state = initialState, action = {}) {
  switch (action.type) {
    case FAILURE_WEATHER:
      return {
        ...state,
        error: action.error,
      };

    case FAILURE_PAST_WEATHER: {
      const newState = {
        ...state,
        pastWeatherError: pastWeatherErrorHandler(action.errors),
      };
      return newState;
    }

    case CLEAR_PAST_WEATHER_FAILURE: {
      const newState = {
        ...state,
        pastWeatherError: initialState.pastWeatherError,
      };
      return newState;
    }

    case REQUEST_HISTORICAL_WEATHER:
    case REQUEST_PAST_WEATHER:
      return {
        ...state,
        isFetching: true,
      };

    case RECEIVE_PAST_WEATHER: {
      const { precip, tmax, tmin, start_date: startDate } =
        action.pastWeatherData.results[0].value;
      const start = moment(startDate).subtract(1, 'd');
      const formattedDates = precip.q.map(() => {
        start.add(1, 'd');
        return start.format('MMM D');
      });

      return {
        ...state,
        isFetching: false,
        formattedDates,
        accumulatedPrecipitation: {
          ...state.accumulatedPrecipitation,
          past: {
            q: accumulateData(precip.q),
            u: precip.u,
          },
        },
        precipitation: {
          ...state.precipitation,
          past: {
            q: precip.q,
            u: precip.u,
          },
        },
        temperature: {
          ...state.temperature,
          past: {
            max: tmax,
            min: tmin,
          },
        },
      };
    }

    case RECEIVE_HISTORICAL_WEATHER: {
      const { value } = action.historicalWeatherData.results[0];
      return {
        ...state,
        accumulatedPrecipitation: {
          ...state.accumulatedPrecipitation,
          historical: {
            q: accumulateData(value.precip.q),
            u: value.precip.u,
          },
        },
        precipitation: {
          ...state.precipitation,
          historical: value.precip,
        },
        temperature: {
          ...state.temperature,
          historical: {
            max: value.tmax,
            min: value.tmin,
          },
        },
      };
    }

    case CLEAR_HISTORICAL_DATA:
      return {
        ...state,
        accumulatedPrecipitation: {
          ...state.accumulatedPrecipitation,
          historical: { ...initialState.accumulatedPrecipitation.historical },
        },
        precipitation: {
          ...state.precipitation,
          historical: { ...initialState.precipitation.historical },
        },
        temperature: {
          ...state.temperature,
          historical: { ...initialState.temperature.historical },
        },
      };

    case UPDATE_PAST_WEATHER_VALUE:
      return {
        ...state,
        [action.input]: action.value,
      };

    case TOGGLE_PRECIPITATION_HELP:
      return {
        ...state,
        precipitation: {
          ...state.precipitation,
          help: !state.precipitation.help,
        },
      };

    case TOGGLE_TEMPERATURE_HELP:
      return {
        ...state,
        temperature: {
          ...state.temperature,
          help: !state.temperature.help,
        },
      };

    default:
      return state;
  }
}

export default pastWeatherReducer;
